<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/homeAll' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="search.flag == 1">实名制上传人员</el-breadcrumb-item>
            <el-breadcrumb-item v-else>实名制未上传人员</el-breadcrumb-item>
  
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 --> 
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <!-- <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all，
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="equipType"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >  
          </el-tree>
        </el-card>
      </el-aside> -->
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
          <div  style=" margin: 10px 20px;display:flex;align-items: center;height:60px">  
          <div class="grid-search">
            <!-- <span>类型:</span>
             <el-select v-model="search.equipType" clearable  @change="doFilter" placeholder="请选择">
              <el-option
                v-for="item in dataTree"
                :key="item.equipType"
                :label="item.name"
                :value="item.equipType"
                 >
              </el-option>
            </el-select> -->
            <el-button-group style="text-align:right;display:block">
              <el-button plain @click="doFilter(1)"  :class="{cur : search.flag==1}">已上传</el-button>
              <el-button plain @click="doFilter(2)"  :class="{cur : search.flag==2}">未上传</el-button>
            </el-button-group>
          </div>
          <div class="grid-search">
            <el-input v-model="search.name" placeholder="请输入人员名称"  clearable >
              <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
            </el-input>
          </div>
             <div class="grid-search">
              <el-input v-model="search.idCard" placeholder="请输入身份证号码"  clearable>
                <el-button slot="append" icon="el-icon-search"  @click="doSearch"></el-button>
              </el-input>
             </div>
          </div>
          <div class="build-table">
            <el-table :data="listData" height="100%" style="width: 100%;" stripe :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a>{{ scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="参建单位" :show-overflow-tooltip="true">
                <template slot-scope="scope" >
                  <span v-if="scope.row.entDeTuoStatus==4" style="color:#0ebd73">√</span>
                  <span v-else style="color:#dd5448">×:{{scope.row.personDeTuoReason.msg||'未上传'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="班组" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.entDeTuoStatus!=4">--</span>
                  <span v-if="scope.row.entDeTuoStatus==4&&scope.row.teamsDeTuoStatus==4" style="color:#0ebd73">√</span>
                  <span v-if="scope.row.entDeTuoStatus==4&&scope.row.teamsDeTuoStatus!=4" style="color:#dd5448">×:{{scope.row.personDeTuoReason.msg||'未上传'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="个人" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.entDeTuoStatus!=4">--</span>
                  <span v-if="scope.row.teamsDeTuoStatus!=4 &&scope.row.personDeTuoStatus!=4">--</span>
                  <span v-if="scope.row.entDeTuoStatus==4&&scope.row.teamsDeTuoStatus==4&&scope.row.personDeTuoStatus==4" style="color:#0ebd73">√</span>
                  <span v-if="scope.row.entDeTuoStatus==4&&scope.row.teamsDeTuoStatus==4&&scope.row.personDeTuoStatus!=4" style="color:#dd5448">×:{{scope.row.personDeTuoReason.msg||'未上传'}}</span>
                </template>
              </el-table-column>
              <el-table-column label="上传次数" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span class="pointhover" style="cursor: pointer;color:#409eff" @click="personInfo(scope.row.projectId,scope.row.idCard)">{{ scope.row.clockSuccessCount }}</span>
                </template>
              </el-table-column>
             <el-table-column label="最近考勤" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>             
            </el-table>
             <!-- 分页展示 -->
            <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination> -->
            <!--  -->
            <div style="text-align: left; padding: 10px 30px;">合计:{{listData.length}}条</div>
            <el-dialog title="考勤明细" :visible.sync="dialogTableVisible">
              <el-table :data="gridData"  height="100%" style="width: 100%;">
                <el-table-column property="index" label="序号" ></el-table-column>
                <el-table-column property="date" label="时间" ></el-table-column>
                <el-table-column property="name" label="姓名" ></el-table-column>
                <el-table-column label="上传状态" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span v-if="scope.row.detuoStatus==0" style="color:#ffc700">待上传</span>
                    <span v-else-if ="scope.row.detuoStatus==1" style="color:#dd5448">上传临时库失败</span>
                    <span v-else-if ="scope.row.detuoStatus==2" style="color:#6ca187">上传临时库成功</span>
                    <span v-else-if ="scope.row.detuoStatus==3" style="color:#dd5448">上传正式库失败</span>
                    <span v-else-if ="scope.row.detuoStatus==4" style="color:#0ebd73">上传正式库成功</span>
                  </template>
                </el-table-column>  
              </el-table>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    var checkPrice = (rule, value, callback) => {
        // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            if (value == '') {
                callback(new Error('请输入单价'))
            } else if (!this.isCellPrice(value)) {
                //引入methods中封装的检查手机格式的方法
                callback(new Error('请输入正确的格式!'))
            } else {
                callback()
            }
        }
    return {
      gridData:[],
      dialogTableVisible:false,
      dataTree: [{name:'喷淋',equipType:'1'},{name:'雾炮',equipType:'2'},{name:'照明',equipType:'3'}],
      listData: [],
      search: {
        name:'',
        flag:'',
        idCard:'',
        //查询
      },
      classId: '', //班组id
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      
    }
  },
  created() {
     if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
      // this.search.projectId = '1226783469518934018'
    }else{
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {

      // this.search.projectId  =util.
      // if (this.dataTree.length > 0) {
      //         this.currentNodekey = this.dataTree[0].equipType
      //         this.expandedkeys.push(this.dataTree[0].equipType)
      //         this.$nextTick(() => {
      //           // treeBox 元素的ref   value 绑定的node-key
      //           this.$refs.tree.setCurrentKey(this.currentNodekey)
      //         })
      //       }
             this.search.flag = this.$route.params.status
             this.getData()
            // this. getMate()
  },
  methods: {
    // 搜索数据
    doSearch() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.getData()
    },
    // 获取数据
    getData() {
        var that = this
        myHttp
          .findTeamsPersonDeTuoReason(this.search)
          .then(
            function(resp) {
              if (resp.data.code == '200') {
              var data =JSON.parse(resp.data.data)
              console.log(data)
              var  list=data.data.list||[]
                for (var i = 0; i < list.length; i++) {
                list[i].index = i+1
                list[i].personDeTuoReason = that.filetJson(list[i].personDeTuoReason)
                list[i].personDeTuoReason= list[i].personDeTuoReason?list[i].personDeTuoReason:''
                // list[i].personDeTuoReason = JSON.parse( list[i].personDeTuoReason)
                // that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                // list[i].content = list[i]. configContent.split('_')[0] +list[i].remark + list[i].configContent.split('_')[1]
              }
              that.listData = list
              console.log(list)
              // that.totalItems=resp.data.data.total||0
              if(list.length==0){
                that.dataText = '暂无数据'
              }
              } else {
                that.$message.error(resp.data.msg)
                that.dataText = '暂无数据'
              }
            },
            function() {
              that.dataText = '服务器繁忙中，请稍后请求'
            }
          )
        },
          //解析方法
          filetJson(obj){
            // console.log(obj instanceof Object)
            // console.log(typeof obj == 'string')
            if(typeof obj === 'string'){  //typeof obj == 'string'
                if(obj.indexOf('[')>-1||obj.indexOf('{')>-1){
                    return JSON.parse(obj)
                }else{
                    return obj
                }
            }
           
        },
        // 搜索数据
    doFilter(index) {
      this.search.flag = index
      this.getData()
    },
    // //获取字典表
    // zidian() {
    //   var that = this
    //   myHttp
    //     .getDictByType({
    //       type: 'user_type'
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.dictList || []
            
    //       }
    //     })
    // },

    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      this.search.equipType = data.equipType
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    getInfo(projectId,idCard){
      var that = this
        myHttp
          .findTeamsPersonDeTuoDetail({
            projectId:projectId,
            idCard:idCard
          })
          .then(
            function(resp) {
              var data =JSON.parse(resp.data.data)
              console.log(data)
              if (data.code == '200') {
              
              var  list=data.data||[]
                for (var i = 0; i < list.length; i++) {
                list[i].index = i+1
                // list[i].personDeTuoReason = JSON.parse( list[i].personDeTuoReason)
                // that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                // list[i].content = list[i]. configContent.split('_')[0] +list[i].remark + list[i].configContent.split('_')[1]
              }
              that.gridData = list
              console.log(list)
              // that.totalItems=resp.data.data.total||0
              if(list.length==0){
                that.dataText = '暂无数据'
              }
              } else {
                that.$message.error(resp.data.msg)
                that.dataText = '暂无数据'
              }
            },
            function() {
              that.dataText = '服务器繁忙中，请稍后请求'
            }
          )
    },
    // 点击查看
    personInfo(projectId,idCard){
      // console.log(projectId)
      this.getInfo(projectId,idCard)
      this.dialogTableVisible =true

    }
    
 

  
  }
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i{
    font-size: 4vh;
    color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 160px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
.content >>>.el-input-group--append .el-input__inner{
  width: 200px;
}
.content >>>.el-tree{
 padding:30px;
}
.grid-search{
  margin-right: 10px;
}
.cur{
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color:#409EFF !important  ;
}
.content >>>.el-dialog{
  height: 80%;
}
.content >>>.el-dialog__body{
  height: 80%;
}
.pointhover :hover{
  color: #0020e6;
}
</style>